<app-layout>
  <!-- <div class="row">
    <div class="col-12">
      <select [ngModel]="selectedSubeId" (ngModelChange)="onChange($event)" class="form-control">
        <option [ngValue]="null" selected>Şube Seçin</option>
        <option [value]="sube.id" *ngFor="let sube of subeler">
          {{sube.isim}}
        </option>
      </select>
    </div>
    <div *ngIf="dashboard" class="col-12">
      <table class="table table-striped" style="margin-top:30px">
        <thead>
          <tr>
            <th>&nbsp;</th>
            <th>Acil</th>
            <th>Yerel</th>
            <th>Satın Alma </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Bu ay içinde açılan talep sayıları</td>
            <td>{{dashboard.acilanAcilTalep}}</td>
            <td>{{dashboard.acilanYerelTalep}}</td>
            <td>{{dashboard.acilanSatinAlmaTalep}}</td>
          </tr>
          <tr>
            <td>Bu ay içinde sonlandırılan talep sayıları</td>
            <td>{{dashboard.sonlananAcilTalep}}</td>
            <td>{{dashboard.sonlananYerelTalep}}</td>
            <td>{{dashboard.sonlananSatinAlmaTalep}}</td>
          </tr>
          <tr>
            <td>Bu ay içinde sonlandırıalan TL talep tutarları</td>
            <td>{{dashboard.tlAcilTalep}}</td>
            <td>{{dashboard.tlYerelTalep}}</td>
            <td>{{dashboard.tlSatinAlmaTalep}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div> -->
  <div class="row">
    <div class="col-md-6 col-xl-4" *ngFor="let sube of subes">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">{{sube.sube}}</h3>
        </div>
        <div class="card-body">
          <app-anasayfa-grafik [datas]="sube.datas"></app-anasayfa-grafik>
        </div>
      </div>
    </div>
  </div>
</app-layout>
